<img [ngSrc]="event.profile.avatar" class="avatar" width="32" height="32" />
<div class="info">
  <div class="user">
    <span class="user-username">{{ event.profile.name | name }}</span>
    <app-level-new class="user-level user-level badge badge_rounded badge_font-l" [level]="event.profile.level"></app-level-new>
  </div>
  <span class="description">
    <span class="typography">
      {{ content.type === 'casebattles' || content.type === 'caseopening' ? 'unboxed' : 'won' }}
    </span>
    <app-icon icon="coin" [width]="14"></app-icon>
    <app-currency [value]="content.amount" [size]="14"></app-currency>
    <span class="typography">|</span>
    <span>{{ content.type }}</span>
  </span>
</div>
@if (content.type === 'casebattles' || content.type === 'caseopening') {
<div class="case-open">
  <img [src]="content.caseimage" class="case-image" />
  <app-icon class="arrow" icon="arrow" />
  <img [src]="content.skinimage" class="skin-image" />
</div>
}
<div class="end-col">
  <span class="icon-container">
    <app-icon class="icon-icon" icon="backpack" />
  </span>
</div>
